var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPadlock = function SvgPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 27
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#5B3552",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.808 26H3.192C1.986 26 1 25 1 23.779V14.22C1 13 1.986 12 3.192 12h15.616C20.013 12 21 13 21 14.221v9.558C21 25 20.013 26 18.808 26Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M3 12V8.953C3 4.561 6.582 1 11 1s8 3.56 8 7.953V12"
  }))));
};
export { SvgPadlock as ReactComponent };
export default __webpack_public_path__ + "images/padlock.svg";